export default "__VITE_ASSET__13bdf8a1__"